/**
 * COL-474: an unsent offset management invoice's amount follows the rent
 * collected, and the DB refuses a hand edit of it
 * (management_invoices_offset_live_fee in
 * 20260925110000_offset_invoice_live_fee.sql raises a check_violation). The
 * edit dialog uses this to show that refusal as a translated message instead
 * of the raw database error.
 */
export function isOffsetLiveFeeEditError(err: unknown): boolean {
  const e = err as { code?: unknown; message?: unknown } | null;
  return (
    e?.code === "23514" &&
    typeof e.message === "string" &&
    e.message.includes("cannot be edited by hand")
  );
}

/**
 * The stable `code` send-invoice puts on a refusal the admin UI translates:
 *   offset_fee_zero          a live offset fee still at 0,00 €
 *   send_lock_failed         the send could not be recorded; nothing emailed
 *   send_already_sent        another window sent it first; nothing emailed
 *   send_amount_changed      the fee moved while sending; nothing emailed
 *   send_not_confirmed       marked sent, but the email may not have arrived
 *   send_canceled            the invoice was canceled (COL-483); nothing emailed
 * supabase-js hides that body behind a generic non-2xx error, so read it off
 * the response — cloned, since a body can only be read once. NULL when the
 * failure carries no code.
 */
export async function sendInvoiceErrorCode(
  err: unknown
): Promise<string | null> {
  const ctx = (err as { context?: unknown } | null)?.context;
  if (!(ctx instanceof Response)) return null;
  try {
    const body = (await ctx.clone().json()) as { code?: unknown } | null;
    return typeof body?.code === "string" ? body.code : null;
  } catch {
    return null;
  }
}
